import { IVector } from "./IVector";

export class Grass{
    position: IVector;
    constructor(position: IVector){
        this.position = position;
    }
}
